import React from 'react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {observer} from 'mobx-react';

interface TooltipProps {
    show: boolean;
    content: string;
    x: number;
    y: number;
}

@observer
export class Tooltip extends TechseeBaseComponent<TooltipProps> {
    renderInternal() {
        const {show, content, x, y} = this.props;

        if (!show) {
            return <div style={{display: 'none'}} />;
        }

        return (
            <div
                className='tooltip-blue'
                style={{
                    left: x,
                    top: y
                }}>
                {content}
            </div>
        );
    }
}
